module.exports = __webpack_public_path__ + "img/icon-user-dark.83361c72.svg";